import { render } from "./IntroductionComponent.vue?vue&type=template&id=674354b6&scoped=true"
import script from "./IntroductionComponent.vue?vue&type=script&lang=js"
export * from "./IntroductionComponent.vue?vue&type=script&lang=js"

import "./IntroductionComponent.vue?vue&type=style&index=0&id=674354b6&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674354b6"]])

export default __exports__